const objectionImg = name =>
  require(`../../homepage/商标异议/images/${name}`)

export const OBJECTION_BANNER = {
  src: objectionImg('商标异议_06.jpg'),
  alt: '商标异议',
  fillLeft: 'var(--color-register-banner-fill-left)',
  fillRight: 'var(--color-register-banner-fill-right)'
}

/** 商标异议页中间内容区（1280px），不含顶部 banner 与页脚 */
export const OBJECTION_PAGE_SECTIONS = [
  {
    type: 'columns',
    items: [
      { src: objectionImg('商标异议_13.jpg'), alt: '01 专业团队' },
      { src: objectionImg('商标异议_11.jpg'), alt: '02 流程透明' },
      { src: objectionImg('商标异议_14.jpg'), alt: '03 合法合规' }
    ]
  },
  {
    type: 'full',
    src: objectionImg('商标异议_17.jpg'),
    alt: '商标异议流程'
  },
  {
    type: 'full',
    src: objectionImg('商标异议_19.jpg'),
    alt: '商标异议适用情形'
  },
  {
    type: 'full',
    src: objectionImg('商标异议_20.jpg'),
    alt: '商标异议常见情形'
  },
  {
    type: 'full',
    src: objectionImg('商标异议_21.jpg'),
    alt: '商标异议服务说明'
  }
]
